import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import HorizontalFormContact from '../components/HorizontalFormContact';
import '../assets/styles/containers/Home.sass';

const Home = () => {
  const [content, setContent] = useState({content: null});
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/general/adventures-general/adventures-general`)
    .then(res => res.json())
    .then(
      (res) => {
        setContent(res.content);
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  return (
    <Layout
      title={content.seo_title_es}
      description={content.seo_content_es}
    >
      <Banner id={59} city="home" thumb="logo_adventures.png"/>
      <HorizontalFormContact />
      
      {ReactHtmlParser(content.content_es)}

      {sponsors &&
        <Sponsors
          items={sponsors}
        />
      }
    </Layout>
  );
}

export default Home;
